"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = void 0;
const isUserAgent_1 = require("./isUserAgent");
exports.isMobile = {
    Android: () => (0, isUserAgent_1.isUserAgent)(/Android/i),
    BlackBerry: () => (0, isUserAgent_1.isUserAgent)(/BlackBerry/i),
    iOS: () => (0, isUserAgent_1.isUserAgent)(/iPhone|iPad|iPod/i),
    Opera: () => (0, isUserAgent_1.isUserAgent)(/Opera Mini/i),
    Windows: () => (0, isUserAgent_1.isUserAgent)(/IEMobile/i) || (0, isUserAgent_1.isUserAgent)(/WPDesktop/i),
    Safari: () => (0, isUserAgent_1.isUserAgent)(/^((?!chrome|android).)*safari/i),
    any: () => exports.isMobile.Android() ||
        exports.isMobile.BlackBerry() ||
        exports.isMobile.iOS() ||
        exports.isMobile.Opera() ||
        exports.isMobile.Windows(),
};
